// Native details and Shopify localization remain usable without JavaScript.
const boundDisclosures = new WeakSet();
const boundLanguages = new WeakSet();
export function preserveLocalizationReturn(form, location = window.location) {
  const value = location.pathname + location.search + location.hash;
  let fields = [...form.querySelectorAll('input[name="return_to"]')];
  if (!fields.length) { const field = form.ownerDocument.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; form.append(field); fields = [field]; }
  for (const field of fields) field.value = value;
  return value;
}
export function initHeader(root = document) {
  for (const details of root.querySelectorAll('[data-header-disclosure]')) {
    if (boundDisclosures.has(details)) continue;
    boundDisclosures.add(details);
    const summary = details.querySelector('summary');
    const sync = () => summary?.setAttribute('aria-expanded', String(details.open));
    sync();
    details.addEventListener('toggle', () => { sync(); if (details.open) for (const other of document.querySelectorAll('[data-header-disclosure]')) if (other !== details) other.open = false; });
    details.addEventListener('keydown', event => { if (event.key !== 'Escape' || !details.open) return; event.preventDefault(); event.stopPropagation(); details.open = false; sync(); summary?.focus(); });
  }
  for (const select of root.querySelectorAll('[data-header-language]')) {
    if (boundLanguages.has(select) || !select.form) continue;
    boundLanguages.add(select);
    const form = select.form;
    form.classList.add('is-enhanced');
    form.addEventListener('submit', () => preserveLocalizationReturn(form));
    select.addEventListener('change', () => { if (select.value === select.dataset.currentLanguage || ![...select.options].some(option => option.value === select.value && !option.disabled)) return; preserveLocalizationReturn(form); if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit(); });
  }
}
if (typeof document !== 'undefined') {
  initHeader();
  document.addEventListener('shopify:section:load', event => initHeader(event.target));
  for (const name of ['pointerdown', 'focusin']) document.addEventListener(name, event => { for (const details of document.querySelectorAll('[data-header-disclosure][open]')) if (!details.contains(event.target)) details.open = false; });
}
